import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import WebMailBottom from '@/components/common/WebMailBottom.vue'
import ContactListItem from '@contact/components/List/ContactListItem.vue'
import { createEventBus, removeEventBus } from '@/util'
import { DeleteMode, FilterComparisonModes, FilterConditions, FilterContainmentModes, WellKnownFolderName } from '@/modules/mail/types'
import api from '@contact/api'
import * as types from '@contact/store/types'
import { ContactsStoredType } from '../types/enums'
import { mapMutations } from 'vuex'
import contact from '../api/contact'
@Component({
  components: { 
    WebMailBottom,
    ContactListItem
  },
  methods: {
    ...mapMutations({
      setSelectAll: types.CONTACT_SELECT_ALL
    })
  }
})
export default class ListContainer extends Vue {
  //
  // ────────────────────────────────────────────────── I ──────────
  //   :::::: P R O P S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────
  //

  @Prop({ type: String, default: null }) id!: string

  //
  // ────────────────────────────────────────────────────────── I ──────────
  //   :::::: M U T A T I O N S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────────
  //

  setSelectAll!: (items: contacts.ContactItem[]) => void

  //
  // ──────────────────────────────────────────────── I ──────────
  //   :::::: D A T A : :  :   :    :     :        :          :
  // ──────────────────────────────────────────────────────────
  //

  contactList: contacts.ContactItem[] = []
  query: string = ''

  //
  // ────────────────────────────────────────────────────── I ──────────
  //   :::::: M E T H O D S : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────
  //

  getContactList() {

    const query = this.query

    const filters: mail.api.FilterOption[] = [
      {
        operator: 'or',
        filters: [
          {
            key: 'ItemClass',
            value: 'IPM.Contact',
            condition: FilterConditions.IsEqualTo,
          },
          {
            key: 'ItemClass',
            value: 'IPM.DistList',
            condition: FilterConditions.IsEqualTo,
          },
        ],
      },
    ];
    
    //#region [검색어 설정]
    if (query) {
      filters.push({
        operator: 'or',
        filters: [
          {
            key: 'DisplayName',
            value: query,
            condition: FilterConditions.ContainsSubstring,
            containmentMode: FilterContainmentModes.Substring,
            comparisonMode: FilterComparisonModes.IgnoreCase,
          },
          {
            key: 'DisplayName',
            value: query,
            condition: FilterConditions.ContainsSubstring,
            containmentMode: FilterContainmentModes.Prefixed,
            comparisonMode: FilterComparisonModes.IgnoreCase,
          },
          {
            key: 'DisplayName',
            value: query,
            condition: FilterConditions.ContainsSubstring,
            containmentMode: FilterContainmentModes.FullString,
            comparisonMode: FilterComparisonModes.IgnoreCase,
          },
          {
            key: 'DisplayName',
            value: query,
            condition: FilterConditions.ContainsSubstring,
            containmentMode: FilterContainmentModes.ExactPhrase,
            comparisonMode: FilterComparisonModes.IgnoreCase,
          },
          {
            key: 'DisplayName',
            value: query,
            condition: FilterConditions.ContainsSubstring,
            containmentMode: FilterContainmentModes.PrefixOnWords,
            comparisonMode: FilterComparisonModes.IgnoreCase,
          },
          {
            key: 'CompanyName',
            value: query,
            condition: FilterConditions.ContainsSubstring,
            containmentMode: FilterContainmentModes.Substring,
            comparisonMode: FilterComparisonModes.IgnoreCase,
          },
          {
            key: 'EmailAddress1',
            value: query,
            condition: FilterConditions.ContainsSubstring,
            containmentMode: FilterContainmentModes.Substring,
            comparisonMode: FilterComparisonModes.IgnoreCase,
          },
          {
            key: 'PidLidEmail1OriginalDisplayName',
            value: query,
            condition: FilterConditions.ContainsSubstring,
            containmentMode: FilterContainmentModes.Substring,
            comparisonMode: FilterComparisonModes.IgnoreCase,
          },
          {
            key: 'MobilePhone',
            value: query,
            condition: FilterConditions.ContainsSubstring,
            containmentMode: FilterContainmentModes.Substring,
            comparisonMode: FilterComparisonModes.IgnoreCase,
          },
          {
            key: 'JobTitle',
            value: query,
            condition: FilterConditions.ContainsSubstring,
            containmentMode: FilterContainmentModes.Substring,
            comparisonMode: FilterComparisonModes.IgnoreCase,
          },
        ],
      });
    }

    // 간편 주소록 (즐겨찾기)
    if (this.id == 'favorite') {
      filters.push({
        key: 'USER_IS_FAVORITE',
        value: 'true',
        condition: FilterConditions.IsEqualTo,
      })
    }

    const data: mail.api.DynamicApiOptions = {
      fields: [],
      filters: filters,
      parentId: this.id == 'favorite' ? null : this.id,
      sorts: [],
      pageSize: 50,//pageSize || 50,
      offset: 0,//nextPageOffset || 0,
      wellKnownParentName: WellKnownFolderName.Contacts,
      type: 'Contact'
    };
    api.contact.getContactsList(data, ContactsStoredType.EWS).then((res) => {
      this.contactList = res.items
      this.isloading(false)
    })
  }

  handleSearchRequest(keyword: string) {
    if (keyword) {
      this.query = keyword
    } else {
      this.query = ''
      this.$emit('searchEnd')
    }
    this.getContactList()
  }

  async deleteItem(list: any[]) {
    if (await(window as any).confirmAsync(this.$t('정말_삭제하시겠습니까').toString())) {
      let ids = list
      let option = DeleteMode.MoveToDeletedItems
      let storedType = ContactsStoredType.EWS
      api.contact.deleteContacts(ids, option, storedType).then((res) => {
        if (res) {
          this.$router.push({ path: '/contact/list' })
        }
      });
    } else {
      return false
    }
  }

  selectAll() {
    this.setSelectAll(this.contactList)
  }

  @Watch('id')
  onChangedFolderId() {
    this.getContactList()
  }

  //
  // ────────────────────────────────────────────────────────── I ──────────
  //   :::::: L I T E C Y C L E : :  :   :    :     :        :          :
  // ────────────────────────────────────────────────────────────────────
  //

  mounted() {
    createEventBus(window, 'header-search', this.handleSearchRequest)
    this.isloading(true)
    this.getContactList()
  }

  beforeDestroy() {
    removeEventBus(window, 'header-search', this.handleSearchRequest)
  }
}
